import base from './base2.repository';
export default {
    getManuals: () => base.get('documentation/manuals'),
}